<template>
  <section class="dashboard">
    <DashboardTitle
      title="Mis Rendimientos"
      description ="Aquí podrás ver la suma de tus rendimientos devengados,
        seleccionando el año y/o filtrando por mes."
    >
    </DashboardTitle>
    <div class="container">
      <div class="userdata">
        Nombre: <b>{{ $store.getters.getFullUserName }}</b><br>
        RFC: <b>{{ $store.getters.getUserRFC }}</b><br>
        Esquema de facturación: <b>{{ billingSchema }}</b><br><br>
      </div>
      <form @submit.prevent="submit" novalidate >
        <fieldset>
          <div class="row row-responsive">
            <div class="column column-xs-100 column-sm-50">
              <label for="">Seleccione el año:</label>
              <span class="select">
                <select v-model="selectedYear">
                  <option v-for="(year, index) in years"
                  :key="index">{{year}}</option>
                </select>
              </span>
            </div>
            <div class="column column-xs-100 column-sm-50">
              <label for="year">Seleccione el mes:</label>
              <span class="select">
                <select v-model="selectedMonth">
                  <option value="0">Todos</option>
                  <option v-for="month in MONTHS.data"
                    :value="month.month"
                    :key="month.id" >
                  {{month.month}}
                  </option>
                </select>
              </span>
            </div>
          </div>
            <div>
              <div>
                <button
                  class="button float-right"
                  @click.prevent="submit()">Enviar
                </button>
              </div>
            </div>
        </fieldset>
      </form>
    </div>
    <div v-if="investorPerformanceList.length !== 0">
      <InvestorPerformanceOverview
        :months="MONTHS"
        :yearlyTotal="investorPerformanceOverview.yearlyTotal"
        :list="investorPerformanceList">
      </InvestorPerformanceOverview>
      <InvestorPerformanceTable
        :investorPerformance ="investorPerformanceList"
        :months ="MONTHS"
        :month = "selectedMonth">
      </InvestorPerformanceTable>
    </div>
    <div v-else>
      <div class="box-no-investments -centered-info">
        <h4 class="maintitle">
          No tienes rendimientos en el intervalo seleccionado.
        </h4>
      </div>
    </div>
  </section>
</template>
<script>

import DashboardTitle from '@/components/SignedTitle'
import InvestorPerformanceTable
  from '@/views/InvestorPerformance/InvestorPerformanceTable'
import InvestorPerformanceOverview
  from '@/views/InvestorPerformance/InvestorPerformanceOverview'
import MONTHS from '@/constants/months'

import userProfileMixin from '@/mixins/userProfileMixin'
import httpRequestMixin from '@/mixins/httpRequestMixin'

export default {
  name: 'InvestorPerformance',
  components: {
    DashboardTitle,
    InvestorPerformanceTable,
    InvestorPerformanceOverview
  },
  mixins: [userProfileMixin, httpRequestMixin],
  data () {
    return {
      investorPerformanceOverview: {
        yearlyTotal: null
      },
      MONTHS,
      selectedMonth: '0',
      selectedYear: new Date().getFullYear(),
      years: [],
      investorPerformanceList: [],
      filteredList: [],
      billingSchema: null
    }
  },
  created: async function () {
    this.getBillingSchema()
    this.getUserData()
    this.sendYear()
    this.getYears()
  },
  methods: {
    translateMonth: function (id) {
      const array = Object.values(this.MONTHS.data)
      const verboseMonth = array.filter((tmp) => {
        if (tmp.id === id) {
          return tmp
        }
      })
      return verboseMonth[0].month
    },
    cleanData: function (arr) {
      let newArr = []
      for (let i = 0; i < arr.length - 1; i++) {
        for (let j = 0; j < arr[i][1].obj.length; j++) {
          let newObj = {}
          newObj.month = this.translateMonth(arr[i][0])
          newObj.total = arr[i][1].total
          newObj.fr = arr[i][1].obj[j].fr
          newObj.value = arr[i][1].obj[j].value
          newArr.push(newObj)
        }
      }
      return newArr
    },
    sendYear: async function () {
      let options = {
        method: 'POST',
        url: process.env.AUTH_BASE + '/investor-performance/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        },
        data: {
          year: this.selectedYear
        }
      }

      const response = await this.httpRequest(options)
      if (response) {
        if (response.status === 200) {
          this.investorPerformanceList =
            this.cleanData(Object.entries(response.data))
          this.investorPerformanceOverview.yearlyTotal = response.data.total
        }
      }
    },
    getBillingSchema: async function () {
      let options = {
        method: 'GET',
        url: process.env.AUTH_BASE + '/investor-profile/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      }

      const response = await this.httpRequest(options)
      if (response) {
        if (response.status === 200) {
          this.billingSchema = response.data.billing_schema
        }
      }
    },
    submit: function () {
      this.sendYear()
    },
    getYears: function () {
      let yearMax = new Date().getFullYear()
      let yearMin = 2018

      for (let i = yearMax; i >= yearMin; i--) {
        this.years.push(i)
      }
    }
  }
}
</script>
<style lang="scss">
.table-investment {
  td,
  th {
    font-size: .9em;
    line-height: 1.2;
  }
  th b {
    color: #999;
  }
}
.userdata{
  margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/views/InvestorPerformance.vue